import   React from 'react';
import {Route, Switch} from "react-router-dom";
import Live from "../pages/Live";
import PrivateRoute from "../components/PrivateRoute"
import CameraConfigSidebar from "../components/CameraConfigSidebar";
import CameraConfigNavbar from "../components/CameraConfigNavbar";
import UserManagement from "../pages/CameraConfig/SystemManagement/UserManagement";
import SystemSettings from "../pages/CameraConfig/SystemManagement/SystemSettings";
import EquipmentMaintenance from "../pages/CameraConfig/SystemManagement/EquipmentMaintenance";
import SystemInformation from "../pages/CameraConfig/SystemManagement/SystemInformation";
import IpSettings from "../pages/CameraConfig/SystemManagement/IpSettings";
import Rtmp from "../pages/CameraConfig/SystemManagement/Rtmp";
import ComparisonParameters from "../pages/CameraConfig/SystemManagement/ComparisonParameters";
import FaceParameters from "../pages/CameraConfig/SystemManagement/FaceParameters";
import EncodingParameters from "../pages/CameraConfig/SystemManagement/EncodingParameters";
import VideoParameters from "../pages/CameraConfig/SystemManagement/VideoParameters";
import UserGroupManagement from "../pages/CameraConfig/FaceLibrary/UserGroupManagement";
import ListLibraryExport from "../pages/CameraConfig/FaceLibrary/ListLibraryExport";
import FaceLibraryImport from "../pages/CameraConfig/FaceLibrary/FaceLibraryImport";
import ComparisonRecord from "../pages/CameraConfig/ComparisonRecord";
import LogRecord from "../pages/CameraConfig/LogRecord";
import RealTimeCapture from "../pages/CameraConfig/RealTimeCapture";
const CameraConfigLayout = () => {
    return (
        <div className="main-layout-design">

            <div className="left-side">
                <CameraConfigSidebar />
            </div>
            <div className="right-side">
                <CameraConfigNavbar />
                <Switch>
                    <PrivateRoute path="/main-cameras/user-management/:id/" exact component={UserManagement} />
                    <PrivateRoute path="/main-cameras/system-settings/:id/" exact component={SystemSettings} />
                    <PrivateRoute path="/main-cameras/equipment-maintenance/:id/" exact component={EquipmentMaintenance} />
                    <PrivateRoute path="/main-cameras/system-information/:id/" exact component={SystemInformation} />
                    <PrivateRoute path="/main-cameras/ip-settings/:id/" exact component={IpSettings} />
                    <PrivateRoute path="/main-cameras/rtmp/:id/" exact component={Rtmp} />
                    <PrivateRoute path="/main-cameras/face-parameters/:id/" exact component={FaceParameters} />
                    <PrivateRoute path="/main-cameras/comparison-parameters/:id/" exact component={ComparisonParameters} />
                    <PrivateRoute path="/main-cameras/encoding-parameters/:id/" exact component={EncodingParameters} />
                    <PrivateRoute path="/main-cameras/video-parameters/:id/" exact component={VideoParameters} />
                    <PrivateRoute path="/main-cameras/face-library-import/:id/" exact component={FaceLibraryImport} />
                    <PrivateRoute path="/main-cameras/face-library-export/:id/" exact component={ListLibraryExport} />
                    <PrivateRoute path="/main-cameras/user-group-management/:id/" exact component={UserGroupManagement} />
                    <PrivateRoute path="/main-cameras/real-time-capture/:id/" exact component={RealTimeCapture} />
                    <PrivateRoute path="/main-cameras/comparison-record/:id/" exact component={ComparisonRecord} />
                    <PrivateRoute path="/main-cameras/log-record/:id/" exact component={LogRecord} />

                </Switch>
            </div>

        </div>
    );
};

export default CameraConfigLayout;